// extracted by mini-css-extract-plugin
export default {"headerContainer":"information_form_headerContainer__+xH2O","title":"information_form_title__Xg3vF"};